module.exports = __webpack_public_path__ + "img/badge.98e704de.png";